/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import getInitialState, { getInitialServerLanguage } from './initial-state';

type Language = {
    languageCodeIso2?: string;
    displayName?: string;
    languageCodeIso3?: string;
};

type LanguageState = {
    preferred?: Language;
    available?: Language[];
    automaticTranslationPreference?: boolean;
    memberCountryCodeIso2?: string | null;
};

const languageSlice = createSlice({
    name: 'language',
    initialState: {} as LanguageState,
    reducers: {
        initialize: (_state, { payload }) => {
            return getInitialState(payload);
        },
        initServerLanguage: (_state, { payload }) => {
            return getInitialServerLanguage(payload);
        },
        setPreferred: (state, action) => {
            state.preferred =
                state.available?.find(
                    (language) => language.languageCodeIso2 === action.payload
                ) || {};
        },
        setAutomaticTranslationPreference: (state, { payload }) => {
            state.automaticTranslationPreference =
                payload.automaticTranslationPreference;
        }
    }
});

export const {
    initialize,
    initServerLanguage,
    setPreferred,
    setAutomaticTranslationPreference
} = languageSlice.actions;
export default languageSlice.reducer;
